export type { HeadingProps } from './types'

export { default } from './Heading'
